import { cn } from "design-system/utils"
import React from "react"

interface ShinyTextProps {
  text: string
  disabled?: boolean
  speed?: number
  className?: string
  baseClassName?: string
  shineColorClass?: string
}

const ShinyText: React.FC<ShinyTextProps> = ({
  text,
  disabled = false,
  speed = 3,
  className = "",
  baseClassName = "text-muted-foreground",
  shineColorClass = "text-muted",
}) => {
  const animationDuration = `${speed}s`

  return (
    <div className={cn("relative inline-block text-base", baseClassName, className)}>
      <span>{text}</span>
      {!disabled && (
        <span
          aria-hidden
          className={cn(
            "absolute inset-0 bg-clip-text animate-shine pointer-events-none",
            shineColorClass,
          )}
          style={{
            backgroundImage:
              "linear-gradient(120deg, rgba(0,0,0,0) 40%, currentColor 50%, rgba(0,0,0,0) 60%)",
            backgroundSize: "200% 100%",
            animationDuration,
            WebkitBackgroundClip: "text",
            WebkitTextFillColor: "transparent",
          }}
        >
          {text}
        </span>
      )}
    </div>
  )
}

export default ShinyText
